import { ILevels } from './../../../../types/exportExcelTypes';
import { Dayjs } from 'dayjs';
import { Range } from 'utils/helperFunctions';
import {
  IGetQuestionById,
  IConditionsMemberGroup,
  DdlRegion,
  DdlQuestionUnit,
  DdlQuestionDepartment,
  DdlQuestionPosition,
  DdlLevel,
} from 'views/pages/questionBank/type';
import { ISectionGroup } from 'views/pages/survey/type';
import { CombineTypeAnswer } from 'views/pages/questionBank/questionAdd/types';
import {
  DdlGroupDivision,
  DdlGroupRestaurant,
} from 'views/pages/survey/surveyAdd/ListOfMembers/types';
import { OptionDetails } from 'components/molecules/AutocompleteVirtualize';

export type TSelectType =
  | 'information'
  | 'content'
  | 'memberList'
  | 'surveyResult'
  | 'release'
  | 'link'
  | 'qrCode'
  | 'reviewSurvey';

export const SelectType: { [key in TSelectType]: TSelectType } = {
  information: 'information',
  content: 'content',
  memberList: 'memberList',
  surveyResult: 'surveyResult',
  release: 'release',
  link: 'link',
  qrCode: 'qrCode',
  reviewSurvey: 'reviewSurvey',
};
export type TSelectTypeListStaff =
  | 'region'
  | 'level'
  | 'position'
  | 'unit'
  | 'department'
  | 'divisions'
  | 'restaurant'
  | 'outlookMail';
export const SelectTypeListStaff: { [key in TSelectTypeListStaff]: TSelectTypeListStaff } = {
  region: 'region',
  level: 'level',
  position: 'position',
  unit: 'unit',
  department: 'department',
  divisions: 'divisions',
  restaurant: 'restaurant',
  outlookMail: 'outlookMail',
};

export type TSelectTypeListCustomer = 'restaurant' | 'feedback';

export const SelectTypeListCustomer: { [key in TSelectTypeListCustomer]: TSelectTypeListCustomer } =
  {
    restaurant: 'restaurant',
    feedback: 'feedback',
  };
/**
 * Status -> 1: Đã phát hành, 2: Đang soạn thảo, 3: Đã kết thúc, 4: Đã khóa.
 * SurveyType -> 1: Public, 2: Private
 * SurveyObject -> 1: Nội bộ, 2: Bên ngoài
 * DisplayFormat -> 1: View all, 2: Highlight 1 câu trả lời
 * AllowedFrequency -> 0: 1 lần, 1: Nhiều lần
 * IsShowResult -> 1: Có, 0: Không ; false: không, true: Có
 * ObjectGroup -> 1: Cá nhân, 2: Nhóm, 3: Tất cả
 */

/******************************************************** */
export enum SurveyStatus {
  PUBLISHED = 'Đã phát hành',
  EDITING = 'Đang soạn thảo',
  FINISHED = 'Đã kết thúc',
  LOGGED = 'Đã khóa',
}

export const SurveyStatusCode = {
  PUBLISHED: 1,
  EDITING: 2,
  FINISHED: 3,
  LOGGED: 4,
};

export enum SurveyForm {
  PUBLIC = 'Ẩn danh',
  PRIVATE = 'Đăng nhập',
}

export enum SurveyTypes {
  NORMAL = 'Khảo sát thường',
  SURVEY_360 = 'Đánh giá 360',
}

export enum SurveyObjects {
  INTERNAL = 'Nhân viên',
  EXTERNAL = 'Khách hàng',
}

export enum SurveyObjects360 {
  SUPERIOR = 'Cấp trên',
  INFERIOR = 'Cấp dưới',
  COUNTERPART = 'Đồng nghiệp/ KH nội bộ',
  SELF_ASSESSMENT = 'Tự đánh giá',
}

export enum DisplayFormat {
  VIEW_ALL = 'View all câu trả lời',
  HIGHLIGHT = 'Highlight 1 câu trả lời',
}

export const surveyObjectGroupConstant: Record<string, number> = {
  user: 1,
  group: 2,
  company: 3,
};

export interface IParentQuestions {
  parentQuestionID: string;
  parentQuestionContent: string;
  numericalOrder: number;
  questions: {
    questionID: string;
    numericalOrder: number;
  }[];
}

export type ISurveySingleQuestion = Omit<IGetQuestionById, 'departments'> & {
  departments: {
    questionID: string;
    departmentID: string;
    departmentName: string;
  }[];
};

export interface ISurveyContent {
  surveyID: string;
  surveyPeopleInfo: string[];
  parentQuestions: ISurveyQuestions[];
}

export interface ISurveyQuestions {
  parentQuestionID: string;
  parentQuestionContent: string;
  questions: ISurveySingleQuestion[];
}
export interface ILinkSurveyQuestionsResponse {
  surveyID: string;
  peopleInfo: string;
  conditionID: string;
  questionsParentQuestions: ISurveyQuestions[];
}

export interface ISubmitSurveyResponse {
  status?: number;
  other?: string;
}

export interface IAnsResultsProps {
  questionID: string;
  answerID?: string;
  categoryID?: string;
  answerContent?: string;
  answerColumnID?: string;
  matrixCategoryID?: string;
}
interface ISurveyPublicInfosProps {
  surveyID: string;
  email: string;
  countryCode?: string | undefined;
  countryName?: string | undefined;
  city?: string | undefined;
  postal?: string | number | null | undefined;
  latitude?: string | undefined;
  longitude?: string | undefined;
  iPv4?: string | undefined;
  state?: string | undefined;
}
export interface ICheckSurveyResultsParams {
  surveyID: string;
  email: string;
  countryCode: string;
  countryName: string;
  city: string;
  postal: string | number | null;
  latitude: string;
  longitude: string;
  iPv4: string;
  state: string;
  phone: string;
  userID: string;
}

export interface IGetInfoClient {
  country_code: string;
  country_name: string;
  city: string;
  postal: string | number | null;
  latitude: number;
  longitude: number;
  IPv4: string;
  state: string;
}
export interface ICheckSurveyResults {
  successMessage: string;
  surveyID: string | null;
  surveyIsLogin: boolean;
  conditionID: string | null;
}

export interface ISurveyAddQuestion {
  surveyID: string;
  surveyPeopleInfo: string[];
  parentQuestions: IParentQuestions[];
}

/** */
export interface ISurveyViewers {
  id: number | null;
  viewerID: string;
  surveyID: string;
  viewerName: string;
  viewerDetail?: string;
}

export interface IDepartment {
  departmentID: string;
  departmentName: string;
  unitID: null | string;
  /** */
  key?: string;
}

export interface ISurvey360Objects {
  objectID: Range<0, 5>;
  objectName: string;
}

export interface IApps {
  appID: string;
  appName: string;
  /** */
  key?: string;
}

// export interface ISurveyInformation {
//   surveyID: string;
//   surveyName: string;
//   status: Range<0, 5>;
//   surveyViewers: {
//     id: number;
//     viewerID: string;
//     surveyID: string;
//     viewerName: string;
//   }[];
//   surveyType: Range<1, 3>;
//   surveyForm: Range<0, 3>;
//   surveyObject: Range<0, 3>;
//   survey360Objects: {
//     objectID: Range<0, 5>;
//   }[];
//   displayFormat: Range<0, 3>;
//   apps: {
//     appID: string;
//     appName: string;
//   }[];
//   campaignID: string;
//   awardee: number;
//   allowedFrequency: Range<1, 3> | boolean;
//   isShowResult: Range<1, 3> | boolean;
//   startDate: string;
//   endDate: string;
//   description: string;
//   thanksContent: string;
//   departments: {
//     departmentID: string;
//     departmentName: string;
//     unitID: string;
//   }[];
//   objectGroup: number;
//   peopleInfo: string[] | null;
// }

export interface IParamFilterEvaluatedQuestionProps {
  regionIDs: {
    regionID: string;
  }[];
  unitIDs: {
    unitID: string;
  }[];
  divisionIDs: {
    divisionID: string;
  }[];
  restaurantsIDs: {
    restaurantID: string;
  }[];
  positionIDs: {
    positionID: string;
  }[];
  levelIDs: {
    levelID: string;
  }[];
  departmentIDs: {
    departmentID: string;
  }[];
}

export interface ISurveyInformation {
  surveyID: string;
  surveyName: string;
  status: Range<0, 5>;
  surveyType: Range<1, 3>;
  surveyForm: Range<0, 3>;
  surveyObject: Range<0, 3>;
  displayFormat: Range<0, 3>;
  campaignID: string;
  awardee: number;
  allowedFrequency: string | boolean;
  isShowResult: string | boolean;
  /** */
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  /** */
  description: string;
  thanksContent: string;
  objectGroup: number;
  peopleInfo: string[] | null;
  userID: string;
  totalBonusCodesMax: number;
  totalBonusCodesSafe: number;
  copySurvey?: boolean;
  isCompleteCopySurvey?: boolean;
  resetStaff?: number;
  surveyBonusCodes: Array<{
    bonusCodeID: string;
  }>;
  regionIDGroups: {
    regionID: string;
  }[];
  unitIDGroups: {
    unitID: string;
  }[];
  divisionIDGroups: {
    divisionID: string;
  }[];
  restaurantsIDGroups: {
    restaurantID: string;
  }[];
  positionIDGroups: {
    positionID: string;
  }[];
  levelIDGroups: {
    levelID: string;
  }[];
  departmentIDGroups: {
    departmentID: string;
  }[];
  /** */
}

export interface ICopySurveyParams {
  surveyID: string;
  userID: string;
}
export interface IGetSurveyInfomation extends ISurveyInformation {
  surveyViewers: ISurveyViewers[];
  survey360Objects: ISurvey360Objects[];
  departments: IDepartment[];
  apps: IApps[];
  userCanViewSurvey?: string[];
  userCanUpdateSurvey?: string[];
}

export interface ISetSurveyInfomation extends Omit<ISurveyInformation, 'startDate' | 'endDate'> {
  surveyViewers: Pick<ISurveyViewers, 'viewerID'>[];
  survey360Objects: Pick<ISurvey360Objects, 'objectID'>[];
  departments: Pick<IDepartment, 'departmentID'>[];
  apps: Pick<IApps, 'appID'>[];
  /** */
  startDate: string;
  endDate: string;
  userCanViewSurvey?: string[];
  userCanUpdateSurvey?: string[];
}

export interface ISurveyUser {
  conditionID: string;
  conditionName: string;
  conditionTextDetail: string;
}

export interface ISurveyLevel {
  unitID: string;
  unitName: string;
}
export interface ISurveyUnit {
  unitID: string;
  unitName: string;
  regionID?: string;
}
export interface ISurveyDepartment {
  departmentID: string;
  departmentName: string;
}
export interface IEmbedApps {
  appID: string;
  appName: string;
}
export interface ISurveyPosition {
  positionID: string;
  positionName: string;
}

export interface ISurveyStaff {
  value: string;
  text: string;
  detailedValue: string;
}

export interface ISurveyStaffResponse {
  nameStatus: string;
  staffPage: ISurveyStaff[];
}

export interface ISurveyStaffProps {
  page: number;
  pageSize: number;
  keyWord: string;
  units: {
    unitID: string;
    surveyID?: string;
  }[];
  regions?: {
    regionID: string;
    surveyID?: string;
  }[];
  divisions?: {
    divisionID: string;
  }[];
  restaurants?: {
    restaurantID: string;
  }[];
  departments: {
    departmentID: string;
    surveyID?: string;
  }[];
  positions: {
    positionID: string;
  }[];
  levels: {
    levelID: string;
  }[];
  survey360Objects: {
    objectID: number;
  }[];
  surveyId: string;
  type?: boolean;
  controller?: AbortController;
}

export interface IParamsFilter360 {
  regions?: IRegions[] | null;
  units?: IUnits[] | null;
  departments?: IDepartments[] | null;
  divisions?: IDivisions[] | null;
  restaurants?: IRestaurants[] | null;
  positions?: IPositions[] | null;
  levels?: ILevels[] | null;
}

interface IParamFilter360Question {
  isSelctAll: boolean;
}
interface IRegionsFilter extends IParamFilter360Question {
  regions: IRegions[] | null;
}
interface IUnitsFilter extends IParamFilter360Question {
  units: IUnits[] | null;
}

interface IDepartmentsFilter extends IParamFilter360Question {
  departments: IDepartments[] | null;
}

interface IDivisionsFilter extends IParamFilter360Question {
  divisions: IDivisions[] | null;
}

interface IRestaurantsFilter extends IParamFilter360Question {
  restaurants: IRestaurants[] | null;
}

interface IIPositionsFilter extends IParamFilter360Question {
  positions: IPositions[] | null;
}

interface ILevelsFilter extends IParamFilter360Question {
  levels: ILevels[] | null;
}

export interface IParamsFilterQuestion360 {
  regions: IRegionsFilter;
  units: IUnitsFilter;
  departments: IDepartmentsFilter;
  divisions: IDivisionsFilter;
  restaurants: IRestaurantsFilter;
  positions: IIPositionsFilter;
  levels: ILevelsFilter;
}
export interface ISurveyUserReview {
  id: number | null;
  surveyID: string;
  viewerID: string;
  viewerName: string;
  viewerDetail?: string;
}

export interface IGroupQuestion {
  questionGroupID: string;
  questionGroupName: string;
}

export interface ISurveyType {
  value: number;
  label: string;
}

export interface IList {
  totalPage: number;
  totalItem: number;
  currentPage: number;
  contents: IContentPeopleSurvey[];
}

export interface IContentPeopleSurvey {
  customerID: string;
  customerName: string;
  phoneNumber: string;
  email: string;
  sex: true;
  staffID: string;
  staffName: string;
  unit: string;
  department: string;
  userName: string;
  checkGroup: 0;
}

export interface IRequestPeopleSearch {
  unit?: string;
  department: string;
  customerID: string;
  position?: string;
  customerName: string;
  page?: number;
  pagesize?: number;
  totalPage?: number;
  totalItem?: number;
}
export interface IStaffs {
  orders?: number;
  staffID: string;
  staffName: string;
  positionName: string;
  levelName: string;
  unitName: string;
  departmentName: string;
  phone: string;
  email: string;
  surveyObject360: string;
}

export interface ICustomer {
  orders?: number;
  customerID: string;
  customerName: string;
  phoneNumber: string;
  email: string;
  sex: boolean | string;
}
export interface IDDLStaff {
  units:
    | [
        {
          unitID: string;
        }
      ]
    | [];
  departments:
    | [
        {
          departmentID: string;
        }
      ]
    | [];
  positions:
    | [
        {
          positionID: string;
        }
      ]
    | [];
  levels:
    | [
        {
          levelID: string;
        }
      ]
    | [];
  survey360Objects:
    | [
        {
          objectID: number;
        }
      ]
    | [];
}

export interface IGetStaffs extends IDDLStaff {
  page: number;
  pageSize: number;
}
export interface IConditionID {
  conditionID: string;
}

export interface IGetStaffsCondition {
  page: number;
  pageSize: number;
  surveyID: string;
  conditions: IConditionID[];
}
export interface IGetCustomer {
  page: number;
  pageSize: number;
  customerName: string;
  phoneNumber: string;
  email: string;
}

export interface ISurveyTotalStatistics {
  numberResponses: number;
  peopleResponses: number;
  percent: string;
}

export interface IListAnswerChildrenCol {
  answerContent: string;
  order: number;
  percent: number;
  isSelect: boolean;
  row: number;
  colum: number;
  categoryName: string;
}

export interface IAnswerInQuestionReport {
  isCategory: boolean;
  questionID: string;
  answerContent: string;
  totalNumber: number;
  percent: number;
  listAnswersChildrenCol: Array<IListAnswerChildrenCol> | null;
}

interface IRatingInQuestionReport {
  averagerating: number;
  numberProcess: number;
}
export interface ISingleQuestionReport {
  questionID: string;
  questionTypeID: string;
  questionContent: string;
  iconType: number;
  totalFeedBack: number;
  listAnswers: Array<IAnswerInQuestionReport>;
  rating: IRatingInQuestionReport | null;
  maxLevel: number;
  questionCategoryID?: number;
}

export interface ISurveyResults {
  feedBack: ISurveyTotalStatistics;
  questionsReports: Array<ISingleQuestionReport>;
}

export interface IRenderQuestionReportParam {
  questionParam: ISingleQuestionReport;
  questionOrder?: number;
}

export interface IUpdateStates {
  infomation: boolean;
  content: boolean;
  listOfUser: boolean;
}

export interface IResultAnalysis {
  documentID: string;
  documentName: string;
}
export interface IFileRes {
  extension: string;
  fileName: string;
  idFile: string;
}
export interface IMemberAnalysis {
  files: IFileRes[];
  surveyId: string;
}

export interface IDDLCategory {
  conditionID: string;
  conditionName: string;
  conditionTextDetail?: string;
}

interface IRegions {
  regionID: string | null;
}
interface IUnits {
  unitID: string | null;
}
interface IDepartments {
  departmentID: string | null;
}
interface IDivisions {
  divisionID: string | null;
}
interface IRestaurants {
  restaurantID: string | null;
}
interface IPositions {
  positionID: string | null;
}

export interface ICategoryDetail {
  categoryID: number;
  regions: IRegions[];
  units: IUnits[];
  departments: IDepartments[];
  divisions: IDivisions[];
  restaurants: IRestaurants[];
  positions: IPositions[];
}

export interface ISurveyStaff360 extends IParamsFilter360 {
  surveyID: string;
  staffs: IDDLCategory[];
}

interface IParamsFilterDetails {
  regionIDs: { regionID: string }[];
  unitIDs: { unitID: string }[];
  departmentIDs: { departmentID: string }[];
  divisionIDs: { divisionID: string }[];
  positionIDs: { positionID: string }[];
  restaurantsIDs: { restaurantID: string }[];
  levelIDs: { levelID: string }[];
}

export interface IAddSurveyStaff360Response {
  item1: IDDLCategory[];
  item2: IParamsFilterDetails;
  item3: any;
}

export interface IUpdateSurveyStaff360Response {
  item1: any;
  item2: IDDLCategory[];
  item3: IParamsFilterDetails;
}

export interface ISurveyStaffParamsAPI extends IParamsFilterQuestion360 {
  surveyID: string;
  staffs: IDDLCategory[];
}

export interface ICategoryStaff {
  value: string;
  text: string;
}
export interface IStaffs360 {
  surveyID: string;
  staffs: ICategoryStaff[];
}

export interface IListOfBonusCode {
  totalItem: number;
  contents: Content[];
}

export interface Content {
  bonusCodeID: string;
}

export interface IGetInfoPeopleSurveyParams {
  email: string;
  surveyID: string;
}

export interface IGetInfoPeopleSurvey {
  infoPeople: string;
}

export interface IQuestionSurveyUploadResponse {
  nameStatus: string;
  questionsParentQuestions: ISurveyQuestions[];
}

export interface ISourceQuestion {
  questionIndex: number;
  sectionID: string;
}

export interface IDestinationQuestion {
  questionIndex: number;
  sectionID: string;
}

export interface IReorderQuestion {
  groupQuestions: ISectionGroup | null;
  sourceQuestion: ISourceQuestion;
  destinationQuestion: IDestinationQuestion;
  newQuestionInfo?: CombineTypeAnswer;
  typeOrder?: 'create' | 'update';
}

export type TConditionSelectGroup = {
  conditionID: string;
};

interface IMemberGroupRequestInfo {
  conditions: IConditionsMemberGroup[];
  isSelectAll: boolean;
  nextPage: number;
  page: number;
  pageSize: number;
  pageSizeNextPage: number;
  surveyID: string;
  keySearch: string;
  conditionSelect: TConditionSelectGroup[];
}

interface IMemberGroupResponseInfo {
  page: number;
  pageSize: number;
  totalItem: number;
  totalPage: number;
}

interface IGroupInfo {
  isSelectAllOption: boolean;
  requestInfo: IMemberGroupRequestInfo;
  responseInfo: IMemberGroupResponseInfo;
}

export interface IMemberGroupInfo {
  regionGroup: IGroupInfo;
  unitGroup: IGroupInfo;
  departmentGroup: IGroupInfo;
  divisionGroup: IGroupInfo;
  restaurantGroup: IGroupInfo;
  positionGroup: IGroupInfo;
  levelGroup: IGroupInfo;
  outlookMail: IGroupInfo;
}
export type IMemberGroupLabel =
  | 'regions'
  | 'units'
  | 'departments'
  | 'divisions'
  | 'restaurants'
  | 'positions'
  | 'levels'
  | 'outlooks';

export interface ILoadingMemberGroupInfo {
  regions: boolean;
  units: boolean;
  departments: boolean;
  divisions: boolean;
  restaurants: boolean;
  positions: boolean;
  levels: boolean;
  outlooks: boolean;
}

export type TActionChangeListMemberGroup = 'searchName' | 'loadNextPage' | 'previousFieldChange';

export interface I360MemberListParamsAPI {
  page: number;
  pageSize: number;
  surveyID: string;
  conditions: {
    conditionID: string;
  }[];
  regions: { regionID: string }[];
  units: { unitID: string }[];
  departments: { departmentID: string }[];
  divisions: { divisionID: string }[];
  restaurants: { restaurantID: string }[];
  positions: { positionID: string }[];
  levels: { levelID: string }[];
}

export interface IGetUserOtherSurveyResponse {
  surveyName: string;
  link: string;
  startDate: string;
  endDate: string;
  id: string;
}
